<script>
import EventBus from './EventBus.js'
export default {
  methods: {
    showToastForEvent (event) {
      this.showToast(event.message.type, event.message.message, event.message.messageType, event.message.details)
    },
    showToast (type, message, messageType, details, onCloseFn) {
      EventBus.$emit('show-toast', { type, message, messageType, details, onCloseFn })
    },
    hideToast () {
      EventBus.$emit('hide-toast')
    }
  }
}
</script>
